import { Component, Input, OnInit } from '@angular/core';

import { ITab } from './tab.interface';

@Component({
  standalone: false,
  selector: 'tabbed-view',
  templateUrl: './tabbed-view.component.html',
  styleUrls: ['./tabbed-view.component.scss']
})
export class TabbedViewComponent implements OnInit {
  @Input() showTabs: boolean;
  @Input() subtitle: string;
  @Input() tabs: Array<ITab>;

  constructor() {}

  ngOnInit() {}
}
